import React from 'react';
import classnames from 'classnames';
import { Table, TableProps, TableColumn } from 'tea-component';
import { getRecordKeyOfMockable } from '@gp/utils/common';
import { getColumnsReadonly } from './utils';

import type { IBaseProps } from '@home/types/common';
import type { IDPSReportProjectCommentsUpdatesVO } from '@gp/types/dpsReport/v3';

interface IReviewCommentTablesProps extends IBaseProps, Omit<TableProps, 'columns'> {
  // 模块数据
  value: IDPSReportProjectCommentsUpdatesVO[];
}

const ReviewCommentTables: React.FC<IReviewCommentTablesProps> = (props) => {
  const { style, className, value: records } = props;

  const columns: TableColumn<IDPSReportProjectCommentsUpdatesVO>[] = getColumnsReadonly();

  return (
    <Table
      style={style}
      className={classnames(
        'dbg-table-vertical-align-top dbg-dps-report__boeder-table dbg-dps-report-project-comments-updates-table dbg-dps-report-project-comments-updates-table--review',
        className,
      )}
      columns={columns}
      records={records}
      recordKey={getRecordKeyOfMockable}
    />
  );
};

export default ReviewCommentTables;
